import { AxiosResponse } from "axios";
import { IPatch } from "../../../components/dashboard-components/fees-component/FeesAccordion";
import useQueryAction from "../../../lib/useQueryAction";
import useQueryMutation from "../../../lib/useQueryMutation";
import {
  api,
  makeDeleteRequest,
  makeGetRequest,
  makePostRequest,
  makePatchRequest,
} from "../../api";
import { StableInfo } from "../../../store";

interface enumType {
  type: null | undefined;
}

export const useAdminUsers = () => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.adminUsers),
    queryKey: ["users"],
  });
};

export const useGetFees = () => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.adminFees),
    queryKey: ["fees"],
  });
};

export const usePatchFees = (Id: string) => {
  return useQueryMutation({
    mutationFn: (data: IPatch) =>
      makePatchRequest(data, api.admin.patchFees(Id)),
  });
};
export const useUpdateBRStatus = (Id?: string) => {
  return useQueryMutation({
    mutationFn: (data: any) => makePatchRequest(data, api.admin.adminUser(Id)),
  });
};

export const useFeeId = (Id: string) => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.feeById(Id)),
    queryKey: ["feeId"],
  });
};
export const useAdminUser = (Id: string) => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.adminUser(Id)),
    queryKey: ["adminUser"],
  });
};

export const useUsetTrnx = (id: string) => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.userTransactions(id)),
    queryKey: ["jgjjgjg"],
  });
};

export const useDeleteFees = (Id: string) => {
  return useQueryMutation({
    mutationFn: () => makeDeleteRequest(api.admin.deleteFees(Id)),
  });
};

export const useFees = () => {
  return useQueryMutation({
    mutationFn: (data: {
      key: any;
      name: any;
      value: {
        amount: any;
        baseValue?: any;
        currency?: any;
      };
      type: any;
      description: any;
    }) => makePostRequest(data, api.admin.adminFees),
  });
};

export const useFunctionality = () => {
  return useQueryMutation({
    mutationFn: (data: {
      feature: string;
      currency: string;
      description: string;
      infoMessage: string;
      status: boolean;
    }) => makePostRequest(data, api.admin.functionality),
  });
};

export const useDeleteFunctionality = (id: string) => {
  return useQueryMutation({
    mutationFn: () => makeDeleteRequest(api.admin.modifyFunctionality(id)),
  });
};

export const useUpdateFunctionality = (id: string) => {
  return useQueryMutation({
    mutationFn: (data: any) =>
      makePatchRequest(data, api.admin.modifyFunctionality(id)),
  });
};
export const useAddRole = (id: string) => {
  return useQueryMutation({
    mutationFn: (data: any) => makePatchRequest(data, api.admin.role(id)),
  });
};

export const useUserPage = () => {
  return useQueryMutation({
    mutationFn: (data: any) => makePatchRequest(data, api.admin.userPage),
  });
};
export const useUserStatus = () => {
  return useQueryMutation({
    mutationFn: (data: any) => makePatchRequest(data, api.admin.userStatus),
  });
};

export const useUpdateFunctionalityGeneral = () => {
  return useQueryMutation({
    mutationFn: (data: any) =>
      makePostRequest(data, api.admin.allFunctionality),
  });
};

export const useCreateTeamMember = () => {
  return useQueryMutation({
    mutationFn: (data: {
      firstName: string;
      lastName: string;
      email: string;
      phoneNumber: string;
    }) => makePostRequest(data, api.admin.teamMember),
  });
};
export const useUserPermission = (id: string) => {
  return useQueryMutation({
    mutationFn: (data: {
      enable?: boolean;
      canWithdraw?: boolean;
      canDeposit?: boolean;
    }) => makePostRequest(data, api.admin.accountPermission(id)),
  });
};
export const useCreateRole = () => {
  return useQueryMutation({
    mutationFn: (data) => makePostRequest(data, api.admin.createRole),
  });
};

export const useGetTeamMembers = () => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.teamMember),
    queryKey: ["xty"],
  });
};
export const useGetRoles = () => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.getadminRole),
    queryKey: ["admin_roles"],
  });
};
export const usePages = () => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.getAppPages),
    queryKey: ["admin_pages"],
  });
};
export const usePagesRole = () => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.getAppPageRole),
    queryKey: ["admin_page_role"],
  });
};

export const useGetFunctionality = () => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.functionality),
    queryKey: ["xitn"],
  });
};

export const useAdminRate = (currency: string) => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.adminRates(currency)),
    queryKey: ["adminRate", currency],
  });
};

export const useAdminTx = (userId: string) => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.adminTx(userId)),
    queryKey: ["adminUser"],
  });
};
export const useGetUserRef = (ref: string) => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.getUserByRef(ref)),
    queryKey: ["adminUserRef"],
    enabled: ref.length === 5,
  });
};
export const useGetPrivilegesByUser = (id: string | null) => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.getUserPrev(id)),
    queryKey: ["adminUserRef"],
    // enabled: id && true,
  });
};

export const useAdminWalletNgn = (userId: string) => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.adminNgn(userId)),
    queryKey: ["ngn"],
  });
};
export const useAdminWalletUsd = (userId: string) => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.adminUsd(userId)),
    queryKey: ["usd"],
  });
};
export const useAdminWalletEur = (userId: string) => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.adminEur(userId)),
    queryKey: ["eur"],
  });
};
export const useAdminWalletGbp = (userId: string) => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.adminGbp(userId)),
    queryKey: ["gbp"],
  });
};
export const useAdminWalletUsdt = (userId: string) => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.adminUsdt(userId)),
    queryKey: ["Usdt"],
  });
};
export const useAdminWalletUsdc = (userId: string) => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.adminUsdc(userId)),
    queryKey: ["Usdc"],
  });
};

export const useBusinessKycStatus = () => {
  return useQueryMutation({
    mutationFn: (data) =>
      makePatchRequest(data, api.admin.businessKycStatus),
  });
};
export const useBusinessContactKycStatus = () => {
  return useQueryMutation({
    mutationFn: (data) =>
      makePatchRequest(
        data,
        api.admin.businessContactKycStatus
      ),
  });
};
export const useBusinessCorporateKycStatus = (businessCorporateId?: string) => {
  return useQueryMutation({
    mutationFn: (data) =>
      makePatchRequest(
        data,
        api.admin.businessCorporateKycStatus(businessCorporateId)
      ),
  });
};

export const useAdminUsersId = (userId: string) => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.getUser(userId)),
    queryKey: ["userId"],
  });
};
export const useEditStableLp = (userId: string) => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.modifyStableLP(userId)),
    queryKey: ["modifyStableLP"],
  });
};
export const useSelectLp = (userId: string) => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.selectLp(userId)),
    queryKey: ["selectLp"],
  });
};

export const useGetLp = () => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.liquidity_partner),
    queryKey: ["lp"],
  });
};
export const useGetStableLp = () => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.stablecoinLP),
    queryKey: ["Slp"],
  });
};

export const useStableLp = () => {
  return useQueryMutation({
    mutationFn: (data: StableInfo): Promise<AxiosResponse<any>> =>
      makePostRequest(data, api.admin.stablecoinLP),
  });
};
export const useGetOffRamp = () => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.offramp),
    queryKey: ["offramp"],
  });
};
export const useGetOnRamp = () => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.onramp),
    queryKey: ["onramp"],
  });
};

// export const useCreateLP = () => {
//   return useQueryMutation({
//     mutationFn: (data: {
//       name: string;
//       bank: string;
//       AccountNumber: string;
//       type: string;
//       otp: string;
//     }) => makePostRequest(data, api.admin.getLp),
//   });
// };

export const useResolveBankName = () => {
  return useQueryMutation({
    mutationFn: (data: {
      bankCode: string;
      accountNumber: string;
    }): Promise<AxiosResponse<any>> =>
      makePostRequest(data, api.admin.resolveBankName),
    // queryKey: [" BankName "]
  });
};

export const useCreateLp = () => {
  return useQueryMutation({
    mutationFn: (data: {
      name: string;
      currency: string;
      bank: string;
      AccountNumber: string;
      AccountName: string;
      withdrawalCurrency: string;
      withdrawalBank: string;
      otp: string;
    }): Promise<AxiosResponse<any>> =>
      makePostRequest(data, api.admin.liquidity_partner),
  });
};

export const useLpOtp = () => {
  return useQueryMutation({
    mutationFn: (data: { email: string }) =>
      makePostRequest(data, api.admin.lpOtp),
  });
};
export const useInvitation = (email: string) => {
  return useQueryMutation({
    mutationFn: (data) => makePostRequest(data, api.admin.invitation(email)),
  });
};

export const useGetLpWallet = (id: string) => {
  return useQueryAction({
    queryFn: () => makeGetRequest(api.admin.getLpById(id)),
    queryKey: ["getLpWallet", id],
  });
};
